const Products = () => {
    return <h1>Products Page</h1>;
};

export default Products;